import React, { Component } from 'react';
import { isEqual } from 'lodash';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import { AlarmCloseCode, CaseSettings } from '../../../../domain/case/CaseDomains';
import ComponentName from '../../../../constant/ComponentName';
import LanguageUtil from '../../../../util/LanguageUtil';

class CaseCloseReasonComponent extends Component<Props, State> {
  public state: State = new State();

  public componentDidMount() {
    this.updateOptions();
  }

  public componentDidUpdate(prevProps: Props) {
    if (!isEqual(prevProps.reasons, this.props.reasons)) {
      this.updateOptions();
    }
  }

  public render() {
    const { value, settings } = this.props;
    const { options } = this.state;
    const isReasonRequired = settings?.reasonRequired === true;

    return (
      <div className='w-full flex flex-col gap-[7px] p-4'>
        <div className='flex w-full items-center justify-between'>
          <div className={'text-sm text-f-black-2'}>
            {isReasonRequired
              ? LanguageUtil.get({ id: 'common.label.required', defaultMessage: '* Required' })
              : LanguageUtil.get({ id: 'common.label.optional', defaultMessage: '* Optional' })}
          </div>
        </div>
        <FormicaSearchSelectBox
          placeholder={LanguageUtil.get({ id: 'common.label.reason', defaultMessage: 'Reason' })}
          options={options}
          value={value}
          onChange={this.onChangeReason}
          data-testid={`${ComponentName.CASE}_close_reason_select`}
        />
      </div>
    );
  }

  private onChangeReason = (e: FormicaSelectBoxItem) => {
    const { onChange } = this.props;
    onChange(e.value);
  };

  private updateOptions = () => {
    const { reasons } = this.props;
    const options = reasons.map((reason) => ({
      label: reason.code,
      value: reason.code,
    }));
    this.setState({ options });
  };
}

interface Props {
  reasons: AlarmCloseCode[];
  value: string | undefined;
  onChange: (value: string) => void;
  settings: CaseSettings;
}

class State {
  options: FormicaSelectBoxItem[] = [];
}

export default CaseCloseReasonComponent;
